import { render, staticRenderFns } from "./menuLevelSecond.vue?vue&type=template&id=3f5ff919&scoped=true"
import script from "./menuLevelSecond.vue?vue&type=script&lang=js"
export * from "./menuLevelSecond.vue?vue&type=script&lang=js"
import style0 from "./menuLevelSecond.vue?vue&type=style&index=0&id=3f5ff919&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5ff919",
  null
  
)

export default component.exports